/**
 * Extracts all dataIndex values from a columns array. 
 * @param {Array} columns
 * @returns {Array<string>}
 */
export function extractColumnDataIndexes(columns) {
    return columns
        .filter(col => typeof col.dataIndex === 'string')
        .map(col => col.dataIndex);
}

/**
 * Removes excluded and exact match fields from include list.
 * @param {Array<string>} includeList
 * @param {Array<string>} excludeList
 * @param {Array<string>} exactList
 * @returns {Array<string>}
 */
export function subtractFields(includeList, excludeList, exactList) {
    const blacklist = new Set([...excludeList, ...exactList]);
    return includeList.filter(field => !blacklist.has(field));
}

/**
 * Performs a case-insensitive regex match after converting to string.
 * @param {string} term
 * @param {any} value
 * @returns {boolean}
 */
export function regexpSearch(term, value) {
    if (value === null) return false;
    return new RegExp(term, 'i').test(String(value));
}

/**
 * Checks if at least one include field matches the search term (partial match).
 * @param {Object} row - The object representing the row data.
 * @param {Array<string>} includeFields
 * @param {string} searchValue
 * @returns {boolean}
 */
export function matchesIncludeFields(row, includeFields, searchValue) {
    return includeFields.some(field => {
        const value = row[field];
        const matched = regexpSearch(searchValue, value);
        return matched;
    });
}

/**
 * Checks if at least one exact field exactly matches the search term.
 * @param {Object} row
 * @param {Array<string>} exactFields
 * @param {string} searchValue
 * @returns {boolean}
 */
export function matchesExactFields(row, exactFields, searchValue) {
    return exactFields.some(field => {
        const value = row[field];
        const matched = String(value) === searchValue;
        // if (matched) {
        //     console.log(`[searchUtilites] Exact Match searchValue="${searchValue}" exactly matched field "${field}" with value:`, value, 'in row:', row);
        // }
        return matched;
    });
}
